module.exports = __webpack_public_path__ + "static/img/bnt.a08483b9.png";